import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function MLAdditionalInterests({ data, interestTypeDisplayMap, show }) {

    if (_.isEmpty(data)) {
        return null;
    }

    if (show) {
        return (
            data.map((additionalInterest) => {
                return(
                    <div className="vertical-spacing-40">
                        <p><strong>{interestTypeDisplayMap[additionalInterest.type]}</strong></p>
                        <p>{additionalInterest.policyAdditionalInterest.displayName}</p>
                        {(additionalInterest.policyAdditionalInterest.primaryAddress.addressLine1)? 
                            <p>{additionalInterest.policyAdditionalInterest.primaryAddress.addressLine1}</p> :
                            <></>
                        }
                        {(additionalInterest.policyAdditionalInterest.primaryAddress.addressLine2)? 
                            <p>{additionalInterest.policyAdditionalInterest.primaryAddress.addressLine2}</p> :
                            <></>
                        }
                        <p>{`${additionalInterest.policyAdditionalInterest.primaryAddress.city  }, ${  additionalInterest.policyAdditionalInterest.primaryAddress.state}`}</p>
                        <p>{additionalInterest.policyAdditionalInterest.primaryAddress.postalCode}</p>
                        {(additionalInterest.contractNumber)?
                            <p>{`Loan #: ${  additionalInterest.contractNumber}`}</p> :
                            <></>
                        }
                    </div>
    
                );
            })
        );
    }
    return ( <></> );
}

MLAdditionalInterests.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    interestTypeDisplayMap: PropTypes.arrayOf(PropTypes.shape({})),
    show: PropTypes.bool
};
MLAdditionalInterests.defaultProps = {
    data: [],
    interestTypeDisplayMap: [],
    show: false
};
export default MLAdditionalInterests;
